export default {
  pendingShiftRequests: [],
  shiftRequestsHistory: [],
};
